import React from 'react';

const sizes = {
    default: `py-3 px-5 text-sm rounded-lg`,
    lg: `lg:py-3 lg:px-10 px-5 py-3 text-sm rounded-lg`,
};

const Button = ({ text, className, href, newTab, size }) => {
    return (
        <div className={className}>
            <a className={`
                ${sizes[size] || sizes.default}
                ${className}
                bg-primary
                hover:bg-primary-darker
                rounded
                text-white
                inline-flex items-center justify-center
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary
            `} href={href} target={newTab && "_blank"}>
                {text}
            </a>
        </div>
    );
};

export default Button;